import createConstant from '../../utils/createConst'
import { API_HOSTNAME } from '../../GlobalConfig'

// import categoryDetailMock from './category-detail.json'
// import filterMock from './filter.json'
// import productMock from './pasar.json'
// import promotedMock from './promoted.json'

const DETAIL = createConstant('category/DETAIL')
const FILTER = createConstant('category/FILTER')
const PRODUCT = createConstant('category/PRODUCT')
const PROMOTED = createConstant('category/PROMOTED')

const initialState = {
  categoryDetailRequest: false,
  categoryDetailError: '',
  categoryDetail: undefined,
  filterRequest: false,
  filterError: '',
  filter: undefined,
  promotedRequest: false,
  promotedError: '',
  promoted: undefined,
  productRequest: false,
  productError: '',
  product: [],
  page: 1,
  total: 0,
  pagination: {
    next: undefined,
    prev: undefined,
    current: 1,
    perPage: 12,
  },
}

export default (state = initialState, action) => {
  switch (action.type) {
    case DETAIL.request:
      return {
        ...state,
        categoryDetailRequest: true,
        categoryDetailError: '',
      }
    case DETAIL.failed:
      return {
        ...state,
        categoryDetailRequest: false,
        categoryDetailError: action.error.message,
        categoryDetail: undefined,
      }
    case DETAIL.success:
      return {
        ...state,
        categoryDetailRequest: false,
        categoryDetailError: '',
        categoryDetail: action.result.result,
      }
    case FILTER.request:
      return {
        ...state,
        filterRequest: true,
        filterError: '',
      }
    case FILTER.failed:
      return {
        ...state,
        filterRequest: false,
        filterError: action.error.message,
        filter: undefined,
      }
    case FILTER.success:
      return {
        ...state,
        filterRequest: false,
        filterError: '',
        filter: action.result.result,
      }
    case PROMOTED.request:
      return {
        ...state,
        promotedRequest: true,
        promotedError: '',
      }
    case PROMOTED.failed:
      return {
        ...state,
        promotedRequest: false,
        promotedError: action.error.message,
        promoted: undefined,
      }
    case PROMOTED.success:
      return {
        ...state,
        promotedRequest: false,
        promotedError: '',
        promoted: action.result.result,
      }
    case PRODUCT.request:
      return {
        ...state,
        productRequest: true,
        productError: '',
      }
    case PRODUCT.failed:
      return {
        ...state,
        productRequest: false,
        productError: action.error.message,
        product: undefined,
      }
    case PRODUCT.success:
      return {
        ...state,
        productRequest: false,
        productError: '',
        product: action.result.result,
        total: action.result.total,
        pagination: action.result.pagination,
      }
    default:
      return state
  }
}

const options = {
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  mode: 'cors',
}

export const getDetail = category => (dispatch) => {
  dispatch({
    types: DETAIL,
    promise: fetch(`${API_HOSTNAME}/v1/category/${category}`, options),
  })

  // dispatch({
  //   type: DETAIL.success,
  // })
}

export const getFilter = category => (dispatch) => {
  dispatch({
    types: FILTER,
    promise: fetch(`${API_HOSTNAME}/v1/category/${category}/product/filter`, options),
  })
}

export const getProductList = (category, page, limit, sort) => (dispatch) => {
  const qParams = `?page=${page}&limit=${limit}&order=${sort}`

  dispatch({
    types: PRODUCT,
    promise: fetch(`${API_HOSTNAME}/v1/category/${category}/product${qParams}`, options),
  })
}

export const getPromoted = (category, page, limit) => (dispatch) => {
  dispatch({
    types: PROMOTED,
    promise: fetch(`${API_HOSTNAME}/v1/category/${category}/product?promoted=1&page=${page}&limit=${limit}`, options),
  })
}



// WEBPACK FOOTER //
// ./src/modules/Category/index.js